<template>
	<svg class="minus-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6 13.5C5.71667 13.5 5.47917 13.4042 5.2875 13.2125C5.09583 13.0208 5 12.7833 5 12.5C5 12.2167 5.09583 11.9792 5.2875 11.7875C5.47917 11.5958 5.71667 11.5 6 11.5H18C18.2833 11.5 18.5208 11.5958 18.7125 11.7875C18.9042 11.9792 19 12.2167 19 12.5C19 12.7833 18.9042 13.0208 18.7125 13.2125C18.5208 13.4042 18.2833 13.5 18 13.5H6Z" fill="black"/>
	</svg>
</template>

<script>
	export default {
		name: 'MinusIcon',
	}
</script>
